import { useState, useEffect } from 'react'
import {
  Wrapper,
  Container,
  Content,
  ChangeImage,
  Image,
  Title,
  Subtitle,
  IconWrapper,
} from './styled'
import { CropImage } from '../cropImage'
import { Tooltip, Button, Upload } from 'antd'
import { RcFile } from 'antd/lib/upload'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImage } from '@fortawesome/pro-solid-svg-icons/faImage'

interface IProps {
  name: string
  image: any
  setImage: Function
}

export const CropImagePreview = ({ name, image, setImage }: IProps) => {
  const [file, setFile] = useState<any>(null)
  const [isCropping, setIsCropping] = useState(false)

  useEffect(() => {
    if (image === null) {
      setFile(null)
    } else {
      if (typeof image === 'string') {
        setFile(image)
      } else {
        setFile(URL.createObjectURL(image))
      }
    }
  }, [image])

  const beforeUpload = (file: RcFile) => {
    setFile(URL.createObjectURL(file))
    setIsCropping(true)
    return false
  }

  const loadImage = (newImage: any) => {
    setImage(name, newImage)
    setIsCropping(false)
  }

  const cancel = () => {
    if (image !== null) {
      if (typeof image === 'string') {
        setFile(image)
      } else {
        setFile(URL.createObjectURL(image))
      }
    } else {
      setFile(null)
    }
    setIsCropping(false)
  }

  return (
    <Wrapper>
      <Upload
        beforeUpload={(file: RcFile) => beforeUpload(file)}
        accept=".jpg, .jpeg, .png"
        showUploadList={false}
      >
        {file ? (
          <Container imageloaded="true">
            <Image url={file} />
            <ChangeImage>
              <Tooltip title="Cambiar imagen" placement="bottom">
                <FontAwesomeIcon icon={faImage} />
              </Tooltip>
            </ChangeImage>
          </Container>
        ) : (
          <Container imageloaded="false">
            <Content>
              <IconWrapper>
                <FontAwesomeIcon icon={faImage} />
              </IconWrapper>
              <Title>SVG, PNG o JPG</Title>
              <Subtitle>(tamaño ideal 228 x 192 px)</Subtitle>
              <Button type="link">Subir imagen</Button>
            </Content>
          </Container>
        )}
      </Upload>
      {isCropping && (
        <CropImage
          title="Imagen del programa"
          image={file}
          loadImage={loadImage}
          variant="round"
          cancel={cancel}
          beforeUpload={beforeUpload}
        />
      )}
    </Wrapper>
  )
}
